import React, { HTMLAttributeAnchorTarget } from 'react';

interface LinkProps {
	onClick?: () => void;
	redirectUrl?: string;
	target?: HTMLAttributeAnchorTarget;
}

export const Link: React.FC<LinkProps> = (props) => {
	const { redirectUrl, target, children, onClick } = props;

	return (
		<a onClick={onClick} href={redirectUrl} target={target} style={{ cursor: 'pointer' }}>
			{children}
		</a>
	);
};
